import React, { Component } from 'react';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux'
import { required, email, numericality } from 'redux-form-validators'
import PropTypes from 'prop-types'
import { Checkbox } from 'antd';
import {toastr} from 'react-redux-toastr'
import moment from 'moment';
import { CirclePicker } from 'react-color';
import InputField from '../../../../../helpers/Fields/InputField';
import { createSlider, updateSlider, getFolderSlider } from '../../../../actions';
import SelectField from '../../../../../helpers/Fields/SelectField';
import TreeSelectField from '../../../../../helpers/Fields/TreeSelectField';
import CheckboxField from '../../../../../helpers/Fields/CheckboxField';
import DateField from '../../../../../helpers/Fields/DateField';


class FormContent extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
  }
  

  submit = async (values)=> {
    try {
      const {formatMessage} = this.context;
      const {handleClose, folder} = this.props;
     
      if(values.id){
        await this.props.updateSlider(values);
        toastr.success(formatMessage('msgNotificationTitleUpdatedSlider'), formatMessage('msgNotificationUpdatedSlider'))
        this.props.getFolderSlider(folder.id)
      } else {
        await this.props.createSlider({...values, folder_id: folder ? folder.id : 0});
        toastr.success(formatMessage('msgNotificationTitleSliderUpdated'), formatMessage('msgNotificationSliderUpdated'))

      }
      
      handleClose();
    } catch (error) {
    }
    
  }

  copy = () => {
    var copyText = document.getElementById("question_frame");
    const {formatMessage} = this.context
    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */

    /* Copy the text inside the text field */
    document.execCommand("copy");
    toastr.success(formatMessage('titleFrameViewCopy'), formatMessage('msgFrameViewCopy'))
  }

  render() {
    const {formatMessage} = this.context
    let { handleSubmit, handleClose, initialValues, folders, valuesForm, siteUrl } = this.props;
    console.log("🚀 ~ file: FormContent.jsx ~ line 61 ~ FormContent ~ render ~ initialValues", valuesForm)


    let isCreate = true;

    if(initialValues.id){
      isCreate = false;
    }


    let tree = [];

    folders.forEach(folder => {
      if(!folder.parent_id){
        tree.push({
          title: folder.title,
          value: folder.id,
          children: []
        })
      }
    });

    folders.forEach(folder => {
      if(folder.parent_id){
        tree.forEach(item => {
          if(item.value == folder.parent_id){
            item.children.push({
              title: folder.title,
              value: folder.id,
            })
          }
        })
      }
    });


    if(!valuesForm){
      valuesForm = {};
    }
    return (
      <form className="create-dialog-form" onSubmit={handleSubmit(this.submit)}>
        <Field 
          name='name'
          label={formatMessage('txtCaptionSliderName')}
          component={InputField}
          validate={[required()]}
          inputProps={{
            autoFocus: isCreate
          }}
        /> 
        {!isCreate && <Field 
          name='folder_id'
          label={formatMessage('txtCaptionSliderFolderName')}
          component={TreeSelectField}
          tree={tree}
          validate={[required()]}
        />}

        {Boolean(valuesForm.id) && Boolean(parseInt(valuesForm.is_view)) && <textarea rows={4} id="question_frame" style={{width: '100%', border: '1px solid #d9d9d9'}}>
          {`<iframe src="${siteUrl}/view/${valuesForm.token_view}" width="100%" height="570" frameborder="0"></iframe>`}
        </textarea>}
        {Boolean(valuesForm.id) && Boolean(parseInt(valuesForm.is_view)) && <div className="flex" style={{alignItems: 'center', justifyContent:'center', marginBottom: 20}}>
          <button className="btn btn-primary" type="button" onClick={this.copy} >{formatMessage('btnViewPresCopy')}</button>
        </div>}
        
        <div className="create-dialog-form__group flex" style={{justifyContent: 'space-between',
            flexDirection: 'row'}}>
          <button className="btn btn-warning" type="button" onClick={() => {
            handleClose();
          }}>{formatMessage('btnModalCancelSlider')}</button>
           <button className="btn btn-primary" type="submit">{formatMessage(!initialValues.id ? 'btnModalCreateSlider': 'btnModalUpdateSlider')}</button>
        </div>
         
      </form>
    );
  }
}

FormContent = reduxForm({
  form: 'form_slider',
  enableReinitialize: true,
})(FormContent);



const mapStateToProps = (state, ownProps) => ({
  valuesForm: getFormValues('form_slider')(state),
  folder: state.slider_folders.item,
  folders: state.slider_folders.list,
})

const mapDispatchToProps = {
  createSlider,
  updateSlider,
  getFolderSlider,
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContent);



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Sliders/components/PresentationItems/components/FormModal/FormContent.jsx